import { colors } from '@indeed/ifl-tokens';
import { StyleSheet, type ViewStyle } from 'react-native';

const toggleBox: ViewStyle = {
    borderWidth: 1,
    borderColor: colors.neutral[400],
    width: '100%',
    padding: 3,
    flexShrink: 1,
    minHeight: 48,
};

export const styles = StyleSheet.create({
    toggleWrapper: {
        width: '100%',
    },
    toggleBoxUnselected: {
        ...toggleBox,
    },
    toggleBoxYes: {
        ...toggleBox,
        backgroundColor: colors.success[200],
    },
    toggleBoxYesText: {
        color: colors.success[800],
    },
    toggleBoxTextAnimated: {
        position: 'absolute',
    },
    toggleBoxAnimatedYes: {
        ...toggleBox,
        backgroundColor: colors.success[700],
    },
    toggleBoxAnimatedNo: {
        ...toggleBox,
        backgroundColor: colors.alert[700],
    },
    toggleBoxNo: {
        ...toggleBox,
        backgroundColor: colors.warning[200],
    },
    toggleBoxNoText: {
        color: colors.warning[800],
    },
});
